import { ParametersViewWrapper } from "../../../../features/ParametersView";
import { IP_RoomAutomation } from "./types";


export function ParameterPanel(props: IP_RoomAutomation) {

    return (<ParametersViewWrapper parentId={props.id} resourceGroupId={props.resourceGroupId} />);
}






